import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  closeIcon: {
    position: 'absolute',
  },
  inputDate: {
    height: 38,
    marginLeft: 5,
    marginRight: 5,
  },
  trashButton: {
    marginLeft: 5
  }
}));
